/** Começo do texto numa linha, para títulos e confirmações. */
export function alertExcerpt(text, max = 80) {
  const line = String(text || "").replace(/\s+/g, " ").trim();
  return line.length > max ? `${line.slice(0, max - 1).trimEnd()}…` : line;
}
